'use client';

import React from 'react';
import useGlobalContext from '$hooks/use-global-context';
import LayoutMobile from '$modules/onboarding/layout/layout.mobile';
import LayoutWeb from '$modules/onboarding/layout/layout.web';
import { type LayoutProps } from './layout.type';
const layout = {
  mobile: LayoutMobile,
  web: LayoutWeb
};
const Layout: React.FC<LayoutProps> = ({
  children
}) => {
  const {
    state
  } = useGlobalContext();
  const LayoutWrapper = state.screen.isMobile ? layout['mobile'] : layout['web'];
  return <LayoutWrapper data-sentry-element="LayoutWrapper" data-sentry-component="Layout" data-sentry-source-file="index.tsx">{children}</LayoutWrapper>;
};
export default Layout;